export default __webpack_public_path__ + "static/final_fantasy_xiv_div-5c978428681200c7ab05a9eaa60926f7.avif";